<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div v-if="$store.state.isLoading" class="loading-overlay" style="z-index: 9999999;">
    <!-- PRELOADER -->
    <div id="preloader">
      <div class="img">
        <img src="../assets/images/hotellogo.png" alt="" />
      </div>
      <span class="preloader-dot"> </span>
    </div>
    <!-- END / PRELOADER -->
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "loading",
  computed: {},
};
</script>

<style scoped lang="scss">
@import "../assets/css/style.css";

.img {
  height: 50px;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  overflow: hidden;
  animation: rotating 4s infinite;
  z-index: 100;

  @keyframes rotating {
    0% {
      transform: translate(-50%, -25px) rotateY(0deg);
    }
    25% {
      transform: translate(-50%, -25px) rotateY(180deg);
    }
    50% {
      transform: translate(-50%, -25px) rotateY(900deg);
    }
    75% {
      transform: translate(-50%, -25px) rotateY(180deg);
    }
    100% {
      transform: translate(-50%, -25px) rotateY(0deg);
    }
  }

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
